var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66675 9.99935C1.66675 5.40018 5.40008 1.66602 10.0001 1.66602C14.6084 1.66602 18.3334 5.40018 18.3334 9.99935C18.3334 14.6002 14.6084 18.3327 10.0001 18.3327C5.40008 18.3327 1.66675 14.6002 1.66675 9.99935ZM9.00559 8.14209L8.99806 8.22547C8.96042 8.57291 8.63672 8.83696 8.2528 8.83696C7.83876 8.83696 7.50001 8.52427 7.50001 8.14209C7.50001 6.63422 9.0357 5.52243 10.6542 5.91155C11.5124 6.11307 12.1974 6.75235 12.4157 7.53755C12.6792 8.47563 12.3103 9.42065 11.5124 9.97655L11.407 10.0599C10.993 10.4004 10.7521 10.866 10.7521 11.3524C10.7521 11.7346 10.4133 12.0473 9.99927 12.0473C9.58524 12.0473 9.24648 11.7346 9.24648 11.3524C9.24648 10.3796 9.75085 9.47624 10.6015 8.87865C10.9252 8.64934 11.0682 8.27411 10.9628 7.88499C10.88 7.58619 10.6015 7.33604 10.2778 7.2596C9.61535 7.09978 9.00559 7.5445 9.00559 8.14209ZM10.8575 13.3745C10.8575 12.9367 10.4735 12.5824 9.99927 12.5824C9.52501 12.5824 9.14109 12.9367 9.14109 13.3745C9.14109 13.8123 9.52501 14.1667 9.99927 14.1667C10.4735 14.1597 10.8575 13.8123 10.8575 13.3745Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.3a2d385c.svg";
export { ForwardRef as ReactComponent };